import { useCallback, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';
import { getCampaignPageUrl, getUrlForPath } from '@bingads-webui-campaign-react/shared-app-capi';
import { isSDK, isFirefoxSDKSignupScenario, getSDKParams } from '@bingads-webui-campaign-react/sdk-utils';
import { useWizardService, getFlowFactor } from '@adsui/wizard';
import { CAMPAIGN_TYPE } from './constants';

const CAMPAIGN_TYPE_MAPPING = {
  [CAMPAIGN_TYPE.SHOPPING]: 'createcampaign/audienceshopping',
  [CAMPAIGN_TYPE.AUDIENCE]: 'createcampaign/displayplus',
  [CAMPAIGN_TYPE.PREMIUM]: 'createcampaign/awareness',
  [CAMPAIGN_TYPE.LODGING]: 'createcampaign/lodging',
};

export const useSubmitToMainBundle = () => {
  const { scope } = useContext(ScopeContext);
  const serverContext = useContext(ServerContext);
  const { state } = useWizardService();

  const isChinaSignup = usePilotsValue('isCNMarketExpansionEnabled');
  const selectedCampaignType = getFlowFactor(state, 'selectedCampaignType');

  const submitToMainBundle = useCallback(({ goToUrl } = {}) => {
    const { campaignId, assetGroupId } = scope.values;
    let mainBundleUrl;
    if (isSDK()) {
      const { mkt } = getSDKParams();
      mainBundleUrl = getCampaignPageUrl(serverContext, 'sdkcampaignoverview', {
        campaignId,
        assetGroupId,
        isSDK: true,
        mkt,
      });

      // For firefox, we need to navigate to sdkintermediate who will call document.requestStorageAccess silently
      // to gain the storage permission of ui.ads.microsoft.com
      if (isFirefoxSDKSignupScenario()) {
        mainBundleUrl = getUrlForPath(serverContext, 'campaign/sdkintermediate', {
          RURL: mainBundleUrl,
        });
      }
    } else if (isChinaSignup) {
      mainBundleUrl = getCampaignPageUrl(serverContext, 'overview');
    } else if (campaignId) {
      mainBundleUrl = getCampaignPageUrl(serverContext, 'overview', { campaignId });
    } else if (selectedCampaignType && CAMPAIGN_TYPE_MAPPING[selectedCampaignType]) {
      mainBundleUrl = getCampaignPageUrl(serverContext, CAMPAIGN_TYPE_MAPPING[selectedCampaignType], {
        politicalAdsAttestationCompleted: true,
      });
    } else {
      mainBundleUrl = getCampaignPageUrl(serverContext, 'createcampaign/objective');
    }

    if (goToUrl) {
      goToUrl(mainBundleUrl);
    } else {
      window.location.replace(mainBundleUrl);
    }
  }, [isChinaSignup, serverContext, selectedCampaignType, scope]);

  return submitToMainBundle;
};
